import { render, staticRenderFns } from "./ProjectCardGeneral.vue?vue&type=template&id=4d85ea1c&scoped=true&"
import script from "./ProjectCardGeneral.vue?vue&type=script&lang=js&"
export * from "./ProjectCardGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardGeneral.vue?vue&type=style&index=0&id=4d85ea1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85ea1c",
  null
  
)

export default component.exports